import { TabError } from '@/utils/class/TabError'
import { ensureExecuteSuccess, deepCopy, sleep, cleanCircleObject } from '@/utils/commonUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { PrintUtils } from '@/utils/PrintUtils'
import StrUtils from '@/utils/StrUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { EstimateProfitUtil } from '@/class/cargo/model/utils/EstimateProfitUtil'
import { CreditControlUtil } from '@/class/cargo/model/utils/CreditControlUtil'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { saveAirImport, saveCopyJob, checkMblRepeatOrNot } from '@/api/AirImport/aiBooking'
import { sendHecMessageByJob, backHecMessageByJob } from '@/api/clearing/charge'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getImGroup } from '@/api/cargoIm'
import {
  isExistHBL,
  shutOut,
  canBatchShutout,
  printProfit,
  calculateProfit,
  commit,
  saveJobInfo
} from '@/api/seaExport/seaExportJob'
import { getDocumentType } from '@/api/documentType'
import { checkJobProvisionFlag, normalizeProvisionLock } from '@/api/provision/provisionData'
import { sendSapMessageByJob } from '@/api/clearing/charge'
import { updateChangeState } from '@/api/clearing/financeManage'
import { backReturn, sendJobCBMS } from '@/api/booking/job'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import { getTrustFromJob } from '@/api/AirExport/airExportJob'
import { updateState } from '@/api/booking/jobCooperate'
import { Company } from '@/class/model/mdm/Company'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import {
  ACTION_ADD,
  LOG_AI_AIR_BOOKING,
  SALES_CHANNEL_OCR_RECOGNITION
} from '@/class/cargo/model/parameters/SystemConstants'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import lodash from 'lodash'
import { DD_STUFFY_TYPE } from '@/class/cargo/model/parameters/AirExportConstants'
import { DIRECT } from '@/class/cargo/model/parameters/ImportConstants'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'

export default {
  methods: {
    // 页面状态切换（action改变）时调用
    async onShow(action, rowData, selectedRow) {
      this.imCacheKey = sessionStorage.getItem('imCacheKey')
      this.action = action
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_AI, action === 'look', selectedRow.jobNo || '')
      /* 先将原始数据赋给currentRow、paramsOfTab，让页面先展示 */
      this.currentRow = selectedRow
      this.paramsOfTab = this.currentRow
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      this.context.loading = true
      try {
        if (selectedRow.uuid) {
          this.rowData = rowData
        } else {
          // CARGO-53866 东丽 新增业务 销售默认带入当前登录人
          await JobUtils.loadingDlwlSales(selectedRow, this)
          this.setJobExtraInfo(selectedRow)
          this.rowData = [...rowData, selectedRow]
        }
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.setGridSelect(selectedRow)
      } catch (err) {
        this.context.loading = false
        throw err
      }
      if (action === 'edit') { // 重新加载业务和费用
        selectedRow.version = 0
        selectedRow.charges = ''
        selectedRow.isCompleteRow = false
      }
      this.onRowClicked({ data: selectedRow })
      if (action === 'look') {
        const cfg = LocalStorageUtils.getConfiguration('AISopStatusPopupVisible')
        this.sopStateDialog.visible = !!cfg
        const logDialogVisible = LocalStorageUtilsNew.getConfiguration('AIDataUpdateLogDialogVisible')
        this.dataUpdateLogDialog.visible = !!logDialogVisible
      }
      this.isCommittedAllowAddCost = Number(this.context.config.get('IsCommittedAllowAddCost')) === 1
    },
    // 切换页面状态
    againShow(action, row) {
      if (action) {
        this.action = action
      }
      if (this.isNew) {
        row = row || {}
      } else {
        row = row || this.currentRow
      }
      this.onShow(this.action, this.rowData, row)
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 设置job的扩展信息
    setJobExtraInfo(job) {
      job.jobUuid = job.uuid
      job.parentUuid = job.lclMasterUuid
      if (job.lclMasterUuid) {
        job.path = job.lclMasterUuid + ',' + job.uuid
      } else {
        job.path = job.uuid
      }
      job.dataType = job.masterFlag ? 1 : 2 // 1 主票 2 小票
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      for (const item of nodes) {
        if (item.data.uuid === row.uuid || !item.data.uuid) {
          this.gridApi.setFocusedCell(item.rowIndex, this.gridApi.columnController.getAllDisplayedColumns()[0])
          break
        }
      }
    },
    // 行点击
    async onRowClicked(event) {
      this.context.loading = true
      this.unread = false
      if (!event.data) {
        this.context.loading = false
        return
      }
      if (this.action === 'look') {
        this.getImGroupFunc(event)
      }
      let data = event.data
      if (data.dataType && Number(data.dataType) !== 1 && Number(data.dataType) !== 2 && data.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === data.jobUuid) {
            data = item
            break
          }
        }
        this.setGridSelect(data)
      }
      let loadCooperate = false
      try {
        // 加载完整信息
        const jobModel = new AirImportJob(data)
        if (data.uuid) {
          await jobModel.loadJobRelated({
            job: true,
            lclSlaves: data.masterFlag,
            lclMaster: !data.masterFlag,
            masterJob: !data.masterFlag, // 冗余的数据（和lclMaster值相同），待调整
            charges: true,
            warehouseIn: true,
            warehouseInfo: true,
            trucking: true,
            airCargoDoc: !data.masterFlag,
            orderCenterMode: this.useOrderCenterMode,
            cooperateBranchId: this.cooperateBranchId
          })
          loadCooperate = true
          // 检查主票下的小票，如果主票有修改，同步将小票放在修改列表中
          if (data.lclSlaves && data.lclSlaves.length > 0) {
            const index = this.saveJobNos.findIndex(p => p.uuid === data.uuid)
            if (index >= 0) {
              for (const slave of data.lclSlaves) {
                const row = this.rowData.find(p => p.uuid === slave.uuid)
                if (row) {
                  for (const key in slave) {
                    if (typeof row[key] === 'object' || key === 'version') {
                      continue
                    }
                    row[key] = slave[key]
                  }
                  this.saveJobNos.push(row)
                }
              }
            }
          }
        } else {
          jobModel.lclSlaves = jobModel.lclSlaves || []
          jobModel.lclMaster = jobModel.lclMaster || null
          jobModel.charges = jobModel.charges || []
          jobModel.warehouseIn = jobModel.warehouseIn || []
          jobModel.warehouseInfo = jobModel.warehouseInfo || []
          jobModel.trucking = jobModel.trucking || []
          jobModel.airCargoDoc = jobModel.airCargoDoc || []
        }
        jobModel.usCustomsClearanceList = ''
        // 需重新构造对象，以便新增加的属性可以被vue监听到
        const newData = { ...data }
        /* 替换旧数据 */
        const index = this.rowData.findIndex(p => p.uuid === data.uuid)
        const node = this.gridApi.rowModel.rowsToDisplay.find(p => p.data.uuid === data.uuid)
        if (index >= 0 && node) {
          this.rowData[index] = newData
          node.data = newData
          data = newData
        }
      } finally {
        this.context.loading = false
      }
      // 协作分公司信息
      if (this.useOrderCenterMode) {
        if (loadCooperate && data.cooperate && data.cooperate.uuid) {
          console.log('data.cooperate===', data.cooperate)
          // 记录原值
          data.opOffice_original = data.opOffice // 分公司
          data.op_original = data.op // 操作
          data.csr_original = data.csr // 客服
          data.overseaOp_original = data.overseaOp // 海外操作
          data.dc_original = data.dc // 单证
          data.planner_original = data.planner // 航线负责人
          data.opDepartment_original = data.opDepartment // 操作部门
          //
          data.opOffice = data.cooperate.branchId // 分公司
          data.op = data.cooperate.opId // 操作
          data.csr = data.cooperate.csrId // 客服
          data.overseaOp = data.cooperate.overseaOp // 海外操作
          data.dc = data.cooperate.dcId // 单证
          data.planner = data.cooperate.planner // 航线负责人
          data.opDepartment = data.cooperate.opDepartment // 操作部门
          JobUtils.convertJobFromCooperateInfo(data, data.cooperate)
          //
          data.cooperateUuid = data.cooperate.uuid
          data.cooperateCooperateStatus = data.cooperate.cooperateStatus
          data.cooperateBusinessType = data.cooperate.businessType
        }
      }
      this.currentRow = data
      this.initInfo()
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.context.removedData = {}
      this.processingPromiseList = []
      this.updateStateInfo()
      if (!event.skipTabHandle) {
        this.$nextTick(() => {
          this.resetActiveTabName()
          this.handleTabClick()
        })
      }
    },
    resetParamsOfTab() {
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
      }
    },
    // 更新业务状态信息
    updateStateInfo() {
      const job = this.currentRow
      const stateInfo = this.stateInfo
      stateInfo.jobState = ColumnUtils.getJobState(job)
      if (this.isCommittedAllowAddCost) {
        stateInfo.jobChangeState = ColumnUtils.getJobChangeState(job)
      }
      const detailModel = Number(this.context.config.get('DetailTitleShowModel')) || 0
      stateInfo.jobNo = detailModel === 0 ? job.jobNo : StrUtils.toHalfwordUpperCase(job.mbl)
      stateInfo.titleMblMid = detailModel === 0 ? this.formatAiJobTitleMawbSegment(job) : ''
      const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
      stateInfo.customer = cmp ? cmp.chineseName : ''
    },
    /** look 导航条中段：主单号，空为「-」，与海出中段规则一致（仅首段为业务编号时展示） */
    formatAiJobTitleMawbSegment(job) {
      if (!job) return '-'
      const raw =
        job.mbl != null && String(job.mbl).trim() !== '' ? job.mbl : job.MBL_NO != null ? job.MBL_NO : ''
      const s = String(raw).trim()
      if (!s) return '-'
      return AirExportUtils.mawbNoDispalyFormat(s) || '-'
    },
    // 重置行数据
    reset(rows) {
      for (const row of rows) {
        // 标识为脏数据
        row.version = 0
        // 重置子表数据
        for (const key in row) {
          if (typeof row[key] === 'object') {
            row[key] = ''
          }
        }
        row.isCompleteRow = false
      }
    },
    // 查看
    lookHandler() {
      this.againShow('look')
    },
    // 编辑
    async toEdit(action) {
      if (this.currentRow.jobState !== 0) {
        this.$message.warning(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(new AirImportJob(this.currentRow))) {
        this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      this.$refs.cargoLeftRightResize.hideLeft()
      if (this.btnGroupLook) {
        this.btnGroupLook.style.display = 'none'
      }
      if (this.btnGroupEdit) {
        this.btnGroupEdit.style.display = ''
      }
      this.$refs.cargoButtonGroupSlider.resizeHandler()
      // 延迟执行，避免阻塞页面渲染
      setTimeout(() => {
        this.againShow(action)
      }, 5)
    },
    // 复制
    toCopy() {
      this.$emit('copy', this.currentRow)
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (fileType !== 'csv') {
        this.$message.warning(this.$t('queryJob.UploadedOnlyBeInFormat'))
      } else {
        return true
      }
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.code === '0') {
        this.onImportSucceeded(response.data)
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message) {
        this.$message.info(this.$t('Message.Page') + message + this.$t('queryJob.ThatSOk'), this.$t('Message.ImportSuccessful1'))
      }
    },
    // 新增
    toAdd(row) {
      this.$emit('add', row || {})
    },
    // 打印
    onPrint() {
      const job = this.currentRow
      if (JobUtils.isBlockJob(job)) {
        this.$message.info(job.jobNo + '已被锁定,不能打印,请联系上级主管解锁!')
        return
      }
      this.$nextTick(async() => {
        // 每个页签的参数
        const params = await this.$refs[this.activeTabName].getPrintData() || null
        if (!params) return
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = job.uuid
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = job.uuid
        }
        console.log('---params--', params)
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.onPrintCallback(params)
        this.templateSelectorDialog.visible = true
      })
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        if (this.$refs[this.activeTabName].prePrintCallback) {
          this.prePrintCallback = event => this.$refs[this.activeTabName].prePrintCallback(event)
        } else {
          this.prePrintCallback = null
        }
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        if (this.$refs[this.activeTabName].printedCallback) {
          this.printedCallback = event => this.$refs[this.activeTabName].printedCallback(event)
        } else {
          this.printedCallback = null
        }
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        if (this.$refs[this.activeTabName].v2CheckCallback) {
          this.v2CheckCallback = (isSure, template, entity, arms) => this.$refs[this.activeTabName].v2CheckCallback(isSure, template, entity, arms)
        } else {
          this.v2CheckCallback = null
        }
      }
    },
    returnReview() {
      if (!this.currentRow) {
        return
      }
      JobUtils.batchReturnReview(this, [this.currentRow])
    },
    // 退关
    async toShutOut() {
      const item = this.currentRow
      const jobKeys = [item.uuid]
      if (item.shutOut) { // 取消退关
        try {
          await this.$confirm('确定要取消作废选中的单据吗？', this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('constant.yes'),
            cancelButtonText: this.$t('constant.no'),
            closeOnClickModal: false,
            type: 'warning'
          })
        } catch (err) {
          return
        }
        this.btnInfo.operateNameCode = Number(SystemConstants.OPERATE_CANCEL_SHUTOUT.code)
        shutOut({ anyStr: item.uuid, location: this.location }).then(res => this.shutOutResult(res))
      } else { // 退关
        try {
          await this.$confirm(this.$t('queryJob.AreSureVoidThisTicket') + this.$t('queryJob.AllChargesBeDeleted'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('constant.yes'),
            cancelButtonText: this.$t('constant.no'),
            closeOnClickModal: false,
            type: 'warning'
          })
        } catch (err) {
          return
        }
        const loading = getLoading4Cxt(this)
        try {
          const body = { job: { ...item }}
          delete body.job.containerUsages
          delete body.job.containers
          const result = await JobUtils.checkBySaveJobNode(body, item.lob, CheckRuleConstants.NO_FEE_REFUND.code)
          if (result.needShowDialog) {
            loading.close()
            const callBack = async() => { canBatchShutout({ jobKeys }).then(res => this.canBatchShutoutResult(res)) }
            this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NO_FEE_REFUND.code
            this.checkingSaveJobWindow.rowData = result.rowData
            this.checkingSaveJobWindow.callBack = callBack
            this.checkingSaveJobWindow.visible = true
          } else {
            canBatchShutout({ jobKeys }).then(res => this.canBatchShutoutResult(res))
          }
        } catch (err) {
          throw err
        } finally {
          loading.close()
        }
      }
    },
    // 退关结果处理
    canBatchShutoutResult(res) {
      const result = Number(res.data)
      if (result === 0) {
        this.btnInfo.operateNameCode = Number(SystemConstants.SHUT_OUT.code)
        shutOut({ anyStr: this.currentRow.uuid, anyBool: false, location: this.location }).then(res => this.shutOutResult(res))
      } else if (result === 1) {
        this.$message.info(this.$t('AirImport.PleaseFormInvoiceEtcVoid'))
      } else if (result === 2) {
        this.$message.info(this.$t('AirImport.PleaseFromTheMasterVoid'))
      } else if (result === 3) {
        this.$message.info(this.$t('AirImport.PleaseFromThisMasterVoid'))
      }
    },
    // 退关结果处理
    shutOutResult(res) {
      const j = res.data
      if (!j) return
      if (this.btnInfo.operateNameCode === Number(SystemConstants.OPERATE_CANCEL_SHUTOUT.code)) {
        this.currentRow.shutOut = false
        this.currentRow.jobState = SystemConstants.OPERATING
      } else {
        this.currentRow.shutOut = true
        this.currentRow.jobState = SystemConstants.SHUT_OUT
      }
      this.reset([this.currentRow])
      this.saveJobNos.push(this.currentRow)
      this.againShow()
      this.$message.info(this.$t('Message.OperationSuccessfully'))
    },
    // 查看关联业务信息
    queryTrustFrom() {
      getTrustFromJob(this.currentRow.trustFromJob).then(res => {
        if (res.data) {
          this.trustFromWindow.trustJob = res.data
          this.trustFromWindow.visible = true
        } else {
          this.$message.warning(this.$t('Message.FailedToQueryTheAssociatedBusiness'))
        }
      })
    },
    // 利润分析打印
    async printProfitEventHandler() {
      this.optName = this.$t('SeaExport.PrintProfitAnalysis')
      this.btnInfo.isPrint = true
      this.btnInfo.isPrintOpr = true
      // 打印利润分析表后是否变更业务状态 0:不变更，1:变为预提交，2:变为已提交
      this.btnInfo.isPreCommit = Number(this.context.config.get('PrintProfitToPreCommit')) === 1
      // 判断是否开启验证规则
      const checkNode = CheckRuleConstants.NODE_PRINT_PROFIT.code
      const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
      // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, checkNode, this.currentRow.opOffice)
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        const callBack = async() => { this.doPrintPROFIT() }
        this.checkingManager(checkNode, callBack, null)
      } else {
        const checkApChargeVerify = Number(this.context.config.get('PreCommitJobCheckApChargeStateVerify')) === 1
        if (this.btnInfo.isPreCommit && checkApChargeVerify && !JobUtils.checkChargeStateVerify(this.currentRow)) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
        this.doPrintPROFIT()
      }
    },
    async doPrintPROFIT() {
      // 当是利润打印按钮事件且 PrintProfitToPreCommit=1、2 时，先打印再提交
      if ([1, 2].includes(Number(this.context.config.get('PrintProfitToPreCommit')))) {
        this.prePintProfitResult({ data: this.currentRow })
      } else {
        calculateProfit(this.currentRow.uuid, -1, this.btnInfo.isPrint, true, this.btnInfo.isPreCommit, this.context.office.officeId, '', this.location).then(res => this.prePintProfitResult(res))
      }
    },
    async prePintProfitResult(res) {
      await this.mergeCurrentRow(res)
      const job = this.currentRow
      this.$nextTick(() => {
        const params = {}
        params.JOB_UUID = job.uuid
        params.jobuuid = job.uuid
        params.showPreview = this.btnInfo.isPrint
        params.isPreCommit = this.btnInfo.isPreCommit
        this.templateSelectorDialog.ctx = new AirImportJob(job)
        this.templateSelectorDialog.category = job.masterFlag ? 'AIPROFIT_PP' : 'AIPROFIT'
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = null
        this.printedCallback = event => {
          this.btnInfo.printEvent = event
          this.btnInfo.isPrintCommit = event.isPreCommit
          if (PrintUtils.isExecutor(event.action)) {
            this.printAlert(true)
          }
        }
        this.v2CheckCallback = (isSure, template, entity, arms) => { this.doPrintPROFIT_V2(isSure, template, entity, arms) }
        this.templateSelectorDialog.visible = true
      })
      this.againShow()
    },
    // 合并当前job【刷新当前job】
    async mergeCurrentRow(res) {
      if (res && res.data) {
        for (const key in res.data) {
          if (typeof this.currentRow[key] === 'object') {
            continue
          }
          this.currentRow[key] = res.data[key]
        }
        if (this.currentRow.masterFlag) {
          this.currentRow.lclSlaves = ''
          await new AirImportJob(this.currentRow).getLclSlaves()
        }
        this.saveJobNos.push(this.currentRow)
        this.isRefresh = true
      }
    },
    // 打印提示
    async printAlert(isProfitPrint = false) {
      const job = this.currentRow
      // 打印利润分析表后是否变更业务状态 0:不变更，1:变为预提交，2:变为已提交
      const printProfitToPreCommit = Number(this.context.config.get('PrintProfitToPreCommit'))
      if (printProfitToPreCommit === 0 || job.jobState === SystemConstants.SHUT_OUT || job.jobState === SystemConstants.VERIFIED ||
      job.jobState === SystemConstants.COMMITED || (job.jobState === SystemConstants.PRE_COMMIT && printProfitToPreCommit === 1)) {
        this.onConfirmedPrintProfit(isProfitPrint)
      } else {
        let msg = this.$t('AirImport.ThisThatRelevantDocumentsContinue')
        if (this.btnInfo.isPreCommit) {
          msg = this.$t('Message.SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
        }
        await this.$confirm(msg, this.$t('common.tips.warning'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.onConfirmedPrintProfit(isProfitPrint, true)
        }).catch()
      }
    },
    async onConfirmedPrintProfit(isProfitPrint = false, isPrint = false) {
      console.log('isProfitPrint:' + isProfitPrint)
      // CARGO-32805 BPM流程引擎二期，提交
      if (await WorkflowUtil.jobSubmitBpm(this, this.btnInfo.operateNameCode, isProfitPrint, this.context.config, this.currentRow)) {
        return
      }
      // 利润打印 按钮逻辑
      // if (isProfitPrint) {
      //   calculateProfit(this.currentRow.uuid, this.btnInfo.operateNameCode, this.btnInfo.isPrintOpr, true, this.btnInfo.isPreCommit, this.context.office.officeId, this.optName).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      //   return
      // }
      // 预提交/提交/主管提交 按钮逻辑
      if (Number(this.context.config.get('useCheckRule')) === 1) {
        printProfit(this.currentRow.uuid, this.btnInfo.operateNameCode, this.context.office.officeId, this.optName, this.location).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      } else {
        calculateProfit(this.currentRow.uuid, this.btnInfo.operateNameCode, this.btnInfo.isPrintOpr, true, this.btnInfo.isPreCommit, this.context.office.officeId, this.optName, this.location).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      }
    },
    async calculateProfit2ResultHandler(res, isProfitPrint = false, isPrint = false) {
      this.optName = ''
      const oldJobState = this.currentRow.jobState
      this.optName = ''
      await this.mergeCurrentRow(res)
      if ((!isProfitPrint || isPrint) && this.btnInfo.printEvent && !PrintUtils.isPrint(this.btnInfo.printEvent.action)) {
        const template = this.btnInfo.printEvent.template
        const parameter = this.btnInfo.printEvent.parameter
        let documentType = null
        if (template && template.documentTypeUuid || !Object.prototype.hasOwnProperty.call(parameter, 'documentType') || !parameter.documentType) {
          await getDocumentType(template.documentTypeUuid).then(res => {
            documentType = res.data ? res.data : null
          })
        }
        if (StimulSoftUtil.isOpenStiReport(template)) {
          parameter.designMode = this.$checkPermission(['role_template_design']) ? 1 : 0
          parameter.documentType = documentType
          await StimulSoftUtil.stiReportPreview(template, this.currentRow, parameter)
        } else {
          const action = this.btnInfo.printEvent.action || ''
          const format = this.btnInfo.printEvent.format || ''
          const url = await PrintTemplateManager.print(template, documentType, format, parameter, action === PrintUtils.PRINT)
          if (url) {
            await this.loadMailURL(url, parameter)
          }
        }
      }
      // 提交成功推送费用
      if (this.commonInfo.operateNameCode === SystemConstants.OPERATE_SUBMISSION.code || this.commonInfo.operateNameCode === SystemConstants.OPERATE_MANAGER_SUBMISSION.code) {
        if (Number(this.context.config.get('openHecConfig')) === 1) {
          const jobs = []
          jobs.push(this.currentRow.uuid)
          if (this.currentRow.masterFlag && this.currentRow.lclSlaves) {
            for (var j of this.currentRow.lclSlaves) {
              jobs.push(j.uuid)
            }
          }
          const params = {}
          params.jobKey = jobs
          params.oldSapStatus = ChargeUtils.CHARGE_US.code
          params.sapStatus = ChargeUtils.CHARGE_SH.code
          params.needUpdateCharge = true
          params.isSend = false
          await sendHecMessageByJob(params).then(rsp => {
            this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
          })
        }
      }
      this.btnInfo.isPrint = true
      this.btnInfo.isPrintOpr = false
      this.againShow()
      if (isProfitPrint && oldJobState === SystemConstants.COMMITED) return // 如果是已提交状态再整箱利润打印，就不需要再弹出提交成功提示
      if (isProfitPrint && Number(this.context.config.get('PrintProfitToPreCommit')) === 0) return // 如果是打印按钮事件 且printProfitToPreCommit=0，不再弹出提交成功提示
      if (isProfitPrint && oldJobState === SystemConstants.PRE_COMMIT) return
      this.$message.success(this.$t('Message.CommitSuccessfully'))
    },
    // 加载MailURLRequest
    async loadMailURL(url, parameter) {
      let status = -1
      const request = new XMLHttpRequest()
      request.open('GET', url, false) // false 同步，默认异步【此处需要同步，需要拿status判断做后续处理】
      request.onload = function(e) {
        status = e.target.status
      }
      request.send()
      if (Object.prototype.hasOwnProperty.call(parameter, 'showPreview') && parameter.showPreview) {
        this.httpResultEmail(status)
      }
    },
    // Mail异常结果处理
    httpResultEmail(status) {
    // 附件过大
      if (status === 0) {
        this.$message.error('附件内容过大')
      } else if (status === 1) {
        this.$message.error(this.$t('SeaExport.SmtpServerError'))
      } else if (status === 2) {
        this.$message.error(this.$t('SeaExport.NotConnectSmtpServer'))
      } else if (status === 3) {
        this.$message.error(this.$t('SeaExport.NotFindFile'))
      } else if (status === 4) {
        this.$message.error(this.$t('SeaExport.SendFileError'))
      } else if (status === 5) {
        this.$message.error(this.$t('SeaExport.AttachTemplateError'))
      } else if (status === 200) {
        this.$message.success(this.$t('SeaExport.MailSentSuccess'))
      }
    },
    // 打印回调函数
    doPrintPROFIT_V2(isSure, template, entity, arms) {
      if (isSure && arms) {
        this.btnInfo.isPreCommit = arms.event.isPreCommit
        if (PrintUtils.isExecutor(arms.event.action)) {
          this.printAlert(true)
        }
      }
    },
    // 验证规则配置公用
    async checkingManager(checkNode, callBack, callBack2) {
      let checkType = true
      if (this.currentRow.masterFlag && checkNode !== CheckRuleConstants.NODE_SAVE_BUSINESS.code) {
        const lclSlaves = this.currentRow.lclSlaves
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = [this.currentRow, ... lclSlaves]
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.visible = true
      }
    },
    // 预提交
    doPreSubmit() {
      this.doCommonSubmit(CheckRuleConstants.NODE_PRE_COMMIT.code)
    },
    // 提交
    doSubmit() {
      this.doCommonSubmit(CheckRuleConstants.NODE_COMMIT.code)
    },
    // 主管提交
    doManagerSubmit() {
      this.doCommonSubmit(CheckRuleConstants.NODE_MANAGER_COMMIT.code)
    },
    // 公用提交逻辑【预提交/提交/主管提交】
    async doCommonSubmit(node) {
      this.optName = ''
      // sap交单验证结算公司
      if (Number(this.context.config.get('openSapConfig')) === 1) {
        for (const item of this.currentRow.charges) {
          if (!item.settleDepartmentPrefix) {
            const cmp = this.context.companyList.find(p => p.cmpIdx === item.accountId)
            this.$message.info((cmp ? cmp.chineseName : '') + this.$t('Message.escnm'))
            return
          }
        }
      }
      const job = this.currentRow
      if (node === CheckRuleConstants.NODE_COMMIT.code || node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
        // 预付款余额校验
        const checkFailUuids = []
        const jobKeys = []
        jobKeys.push(job.uuid)
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.indexOf(job.uuid) !== -1) {
          return
        }
      }
      this.btnInfo.isPreCommit = node === CheckRuleConstants.NODE_PRE_COMMIT.code
      if (node === CheckRuleConstants.NODE_PRE_COMMIT.code) {
        this.btnInfo.operateNameCode = SystemConstants.OPERATE_PRE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_COMMIT.code) {
        this.btnInfo.operateNameCode = SystemConstants.OPERATE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
        this.btnInfo.operateNameCode = SystemConstants.OPERATE_MANAGER_SUBMISSION.code
      }
      this.btnInfo.isPrintOpr = false
      const checkApChargeVerify = Number(this.context.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (this.btnInfo.isPreCommit && checkApChargeVerify === 1) {
        const isPass = await JobUtils.checkChargeStateVerify(job)
        if (!isPass) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
      }
      // 判断是否开启验证规则
      const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
      // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, node, this.currentRow.opOffice)
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        const callBack = () => { this.doSubmitCallBack() }
        this.checkingManager(node, callBack, null)
      } else {
        if (job.jobState === SystemConstants.PRE_COMMIT) {
          await this.loadChargesHandler()
          return
        }
        this.btnInfo.isPrint = false
        await this.jobProfitPrint()
      }
    },
    async doSubmitCallBack() {
      const job = this.currentRow
      let commitSuccess = this.commitResultHandler
      const openPushChargeConfig = Number(this.context.config.get('openPushChargeConfig')) === 1
      const commitOpenAutoPushJobToCBMS = Number(this.context.config.get('CommitOpenAutoPushJobToCBMS')) === 1
      if (openPushChargeConfig && !this.btnInfo.isPreCommit) {
        commitSuccess = this.commitSapResultHandler
      }
      if (commitOpenAutoPushJobToCBMS &&
          (this.btnInfo.operateNameCode === SystemConstants.OPERATE_SUBMISSION.code ||
              this.btnInfo.operateNameCode === SystemConstants.OPERATE_MANAGER_SUBMISSION.code)) {
        commitSuccess = this.commitCBMSResultHandler
      }
      if (Number(this.context.config.get('openHecConfig')) === 1) {
        commitSuccess = this.commitHecSapResultHandler
      }
      // CARGO-32805 BPM流程引擎二期，提交
      if (await WorkflowUtil.jobSubmitBpm(this, this.btnInfo.operateNameCode, null, null, this.currentRow)) {
        return
      }
      commit(job.uuid, this.btnInfo.operateNameCode, this.btnInfo.isPreCommit, this.context.office.officeId, this.location).then(res => {
        commitSuccess(res)
      })
    },
    /**
     * 开启sap推送 发送sap消息
     * @private
     */
    async commitHecSapResultHandler(res) {
      const job = this.currentRow
      const jobs = []
      jobs.push(job.uuid)
      if (job.masterFlag && job.lclSlaves) {
        for (const j of job.lclSlaves) {
          jobs.push(j.uuid)
        }
      }
      const params = {}
      params.jobKey = jobs
      params.oldSapStatus = ChargeUtils.CHARGE_US.code
      params.sapStatus = ChargeUtils.CHARGE_SH.code
      params.needUpdateCharge = true
      params.isSend = false
      await sendHecMessageByJob(params).then(rsp => {
        this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        this.commitResultHandler(res)
      })
    },
    async backReturnSapResultHandler(res) {
      const job = this.currentRow
      const jobs = []
      jobs.push(job.uuid)
      if (job.masterFlag && job.lclSlaves) {
        for (const j of job.lclSlaves) {
          jobs.push(j.uuid)
        }
      }
      const params = {}
      params.jobKey = jobs
      params.oldSapStatus = 'all'
      params.sapStatus = ChargeUtils.CHARGE_US.code
      params.needUpdateCharge = true
      params.isSend = false
      await backHecMessageByJob(params).then(rsp => {
        this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        this.commitResult2Handler(res)
      })
    },
    /**
     * 开启CBMS推送 发送CBMS消息
     * @private
     */
    async commitCBMSResultHandler(res, type = '0') {
      const params = {}
      const job = this.currentRow
      params.uuid = job.uuid
      params.isDisable = type
      params.officeId = this.$store.getters.currentOfficeId
      await sendJobCBMS(params).then(rsp => {
        if (!rsp.data || rsp.data === 'fail') {
          this.$message.error(this.$t('CargoMsg.Cargo_PushFailByCBMS'))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_PushSuccessByCBMS'))
        }
        this.commitResult2Handler(res)
      })
    },
    async commitResultHandler(res) {
      await this.mergeCurrentRow(res)
      this.againShow()
      this.$message.success(this.$t('Message.CommitSuccessfully'))
    },
    async commitResult2Handler(res) {
      await this.mergeCurrentRow(res)
      this.againShow()
    },
    async commitSapResultHandler(res) {
      await this.mergeCurrentRow(res)
      if (Number(this.context.config.get('openSapConfig')) === 1) {
        const params = {}
        params.jobKey = [this.currentRow.uuid]
        params.oldSapStatus = ChargeUtils.CHARGE_NULL.code
        params.sapStatus = ChargeUtils.CHARGE_SH.code
        params.needUpdateCharge = true
        await sendSapMessageByJob(params).then(res => {
          this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        })
        this.currentRow.charges = ''
      }
      this.againShow()
    },
    async loadChargesHandler() {
      // CARGO-32805 BPM流程引擎二期，提交
      if (await WorkflowUtil.jobSubmitBpm(this, this.btnInfo.operateNameCode, null, null, this.currentRow)) {
        return
      }
      const job = this.currentRow
      job.jobState = SystemConstants.COMMITED
      await this.refreshChargeState(job)
      job.operateNameCode = this.btnInfo.operateNameCode
      job.submissionDate = DateUtils.formatStandardDateTime(new Date())
      job.commitUser = this.$store.getters.userId
      await saveJobInfo(this.getBasicTypeObject(job)).then(res => {
        job.charges = ''
        for (const item of job.lclSlaves) {
          item.charges = ''
        }
        job.isCompleteRow = false
        this.commitResultHandler(res)
      })
    },
    async refreshChargeState(job) {
      for (const item of job.charges) {
        if (item.chargeState === BillingConstants.CHARGE_STATE_NORMAL.code) {
          item.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
        }
      }
      if (job.masterFlag) {
        for (const lclJob of job.lclSlaves) {
          const charges = await new AirImportJob(lclJob).getCharges()
          for (const charge of charges) {
            if (charge.chargeState === BillingConstants.CHARGE_STATE_NORMAL.code) {
              charge.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
            }
          }
        }
      }
    },
    // 获取一个只有基本类型属性的对象副本
    getBasicTypeObject(job) {
      const result = { ...job }
      for (const key in result) {
        if (typeof result[key] === 'object') {
          delete result[key]
        }
      }
      return result
    },
    async jobProfitPrint() {
      const job = this.currentRow
      const pass = await this.checkOverseaBilling(job)
      if (!pass) {
        this.$message.info(this.btnInfo.isPrint ? this.$t('AirImport.ThereBillNumbersProfitPrinted') : this.$t('AirImport.ThereBillNumbersProfitSubmitted'))
        return
      }
      // CARGO-32805 BPM流程引擎二期，提交
      if (await WorkflowUtil.jobSubmitBpm(this, this.btnInfo.operateNameCode, null, null, this.currentRow)) {
        return
      }
      await calculateProfit(this.currentRow.uuid, SystemConstants.PENDING, this.btnInfo.isPrintOpr, true, this.btnInfo.isPreCommit, this.context.office.officeId, '', this.location).then(res => {
        this.commitResultHandler(res)
      })
    },
    async checkOverseaBilling(job) {
      let pass = true
      const charges = await new AirImportJob(job).getCharges()
      for (const charge of charges) {
        if (charge.oversea && !charge.paidOff) {
          if (!charge.billing || !charge.billing.billingNo) {
            pass = false
            break
          }
        }
      }
      if (pass && job.lclSlaves && job.lclSlaves.length > 0) {
        for (const slave of job.lclSlaves) {
          pass = this.checkOverseaBilling(slave)
          if (!pass) {
            break
          }
        }
      }
      return pass
    },
    // 检查是否有收费用未开发票
    async getChargeIsInvoiceResult(res) {
      const flag = res.data
      if (flag) {
        const msg = this.btnInfo.isPrint ? this.$t('Message.ThereAreFeesReceivableNotInvoicedPrint') : this.$t('Message.ThereAreFeesReceivableNotInvoicedSubmit')
        await this.$confirm(msg, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          await this.printAlert()
        }).catch(() => {
          this.btnInfo.isPrint = true
        })
      } else {
        await this.printAlert()
      }
    },
    // 主管审核
    async doSubmitAudit_ManagerSubmit() {
      this.optName = ''
      const job = this.currentRow
      const checkApChargeVerify = parseInt(this.context.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (checkApChargeVerify === 1 && !(await JobUtils.checkChargeStateVerify(job))) {
        this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
        return
      }
      const callBack = () => { this.getDoSubmitAudit_ManagerSubmit() }
      const callBack2 = () => { this.getDoSubmitAudit_ManagerSubmit2() }
      this.checkingManager(10, callBack, callBack2)
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit() {
      commit(this.currentRow.uuid, SystemConstants.OPERATE_SUBMISSION.code, false, this.context.office.officeId, this.location).then(async res => {
        await this.mergeCurrentRow(res)
        this.againShow()
      })
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit2() {
      this.btnInfo.showMessage = false
      this.loadChargesPrintReturnHandler()
    },
    async loadChargesPrintReturnHandler() {
      const job = this.currentRow
      job.jobState = SystemConstants.OPERATING
      const submitChargeState = Number(this.context.config.get('CommitJobChangedChargeState')) === 1
      if (submitChargeState) {
        await this.refreshChargeState(job)
      }
      job.manageAuditStatus = 0
      job.operateNameCode = this.btnInfo.operateNameCode
      await saveJobInfo(this.getBasicTypeObject(job)).then(async res => {
        await this.mergeCurrentRow(res)
        job.charges = ''
        for (const item of job.lclSlaves) {
          item.charges = ''
        }
        job.isCompleteRow = false
        this.againShow()
        if (this.btnInfo.showMessage) {
          this.$message.info(this.$t('Message.AlreadyWithdraw'))
        } else {
          this.btnInfo.showMessage = true
        }
      })
    },
    // 退回操作/撤回
    async backReturn() {
      const job = this.currentRow
      let txt = ''
      if (job.jobState === SystemConstants.COMMITED) {
        this.btnInfo.operateNameCode = SystemConstants.OPERATE_PRINT_RETURN.code
        txt = this.$t('Message.Withdraw')
      } else if (job.jobState === SystemConstants.PRE_COMMIT) {
        this.btnInfo.operateNameCode = SystemConstants.OPERATE_RETURN_ACTION.code
        txt = this.$t('Message.ReturnAction')
      } else {
        return
      }
      const operate = this.job.jobState === SystemConstants.PRE_COMMIT ? SystemConstants.OPERATE_RETURN_ACTION.code : SystemConstants.OPERATE_PRINT_RETURN.code
      if (!await JobUtils.backCheckJobState([this.job.uuid], operate, this.job)) {
        this.againShow()
        return
      }
      this.$confirm(this.$t('Message.IsConfirm') + txt + '？', this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        const loading = getLoading4Cxt()
        backReturn({ jobUuids: [job.uuid], lob: 'AI', location: this.location }).then(async res => {
          if (Number(this.context.config.get('CommitOpenAutoPushJobToCBMS')) === 1 &&
              this.btnInfo.operateNameCode === SystemConstants.OPERATE_PRINT_RETURN.code) {
            this.commitCBMSResultHandler(res, '1')
          } else if (Number(this.context.config.get('openHecConfig')) === 1) {
            this.backReturnSapResultHandler(res)
          } else {
            await this.mergeCurrentRow(res)
            job.charges = ''
            for (const item of job.lclSlaves) {
              item.charges = ''
            }
            job.isCompleteRow = false
            this.againShow()
          }
          if (this.btnInfo.showMessage) {
            this.$message.info(this.$t('Message.AlreadyWithdraw'))
          } else {
            this.btnInfo.showMessage = true
          }
        }).finally(() => {
          loading.close()
        })
      }).catch()
    },
    // 提交改单费用
    changeCommit_clickHandler() {
      this.$confirm(this.$t('SeaExport.ConfirmChangeCommit'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        updateChangeState(Array.of(this.currentRow.uuid), { changeState: SystemConstants.CHANGE_COMMIT.code, location: this.location }).then(res => this.updateChangeStateHandler(res))
      }).catch(() => { })
    },
    updateChangeStateHandler(res) {
      this.commitResultHandler({ data: res.data[0] })
    },
    // 批量处理费用
    chargeHandle() {
      switch (this.chargeCommand) {
        case this.$t('SeaExport.AddCharges'):
          this.toAddCharge()
          break
        case this.$t('SeaExport.ChargeImport'):
          this.toImportCharge()
          break
      }
    },
    // 新增费用
    toAddCharge() {
      const selectedJobs = []
      if (this.currentRow.jobState === SystemConstants.OPERATING) {
        selectedJobs.push(this.currentRow)
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      this.addChargeDetailDialog.selectedJobs = selectedJobs
      this.addChargeDetailDialog.selectedScheme = []
      this.addChargeDetailDialog.visible = true
    },
    // 批量导入费用
    toImportCharge() {
      if (this.currentRow.jobState !== SystemConstants.OPERATING) {
        this.$message.warning(this.$t('Message.AllDataMustBeOperating'))
        return
      }
      const selectedJobs = [this.currentRow]
      /* 将相同的委托单位、订舱代理、承运人、整拼类型、货物类型、起运港、目的港、目的港代理带入到费用方案窗口 */
      let isSameCustomer = true
      let isSameBookingAgent = true
      let isSameCarrierId = true
      let isSameOperateType = true
      let isSameCargoType = true
      let isSameLoadingPort = true
      let isSameDestinationPort = true
      let isSameDestinationAgent = true
      let isSameVesselLine = true
      const operateType = selectedJobs[0].operateType
      const customerId = selectedJobs[0].customerId
      const bookingAgent = selectedJobs[0].bookingAgent
      const carrierId = selectedJobs[0].carrierId
      const cargoType = selectedJobs[0].cargoType
      const loadingPort = selectedJobs[0].loadingPortCode
      const destinationPort = selectedJobs[0].destinationPortCode
      const destinationAgent = selectedJobs[0].destinationAgent
      let vesselLine = ''
      const port = getObjectByCache(basicCacheKeys.basic_data_Airport, 'code', selectedJobs[0].destinationPortCode)
      if (port) {
        vesselLine = port.region
      }
      for (const airExportJob of selectedJobs) {
        if (customerId !== airExportJob.customerId) {
          isSameCustomer = false
        }
        if (bookingAgent !== airExportJob.bookingAgent) {
          isSameBookingAgent = false
        }
        if (carrierId !== airExportJob.carrierId) {
          isSameCarrierId = false
        }
        if (operateType !== airExportJob.operateType) {
          isSameOperateType = false
        }
        if (cargoType !== airExportJob.cargoType) {
          isSameCargoType = false
        }
        if (loadingPort !== airExportJob.loadingPortCode) {
          isSameLoadingPort = false
        }
        if (destinationPort !== airExportJob.destinationPortCode) {
          isSameDestinationPort = false
        }
        if (destinationAgent !== airExportJob.destinationAgent) {
          isSameDestinationAgent = false
        }
        const airPort = getObjectByCache(basicCacheKeys.basic_data_Airport, 'code', airExportJob.destinationPortCode)
        if (airPort && vesselLine !== airPort.region) {
          isSameVesselLine = false
        }
      }
      const sameCondition = {}
      if (isSameCustomer) {
        sameCondition['customerId'] = customerId
      }
      if (isSameBookingAgent) {
        sameCondition['bookingAgent'] = bookingAgent
      }
      if (isSameCarrierId) {
        sameCondition['carrierId'] = carrierId
      }
      if (isSameOperateType) {
        sameCondition['containerLoadType'] = operateType
      }
      if (isSameCargoType) {
        sameCondition['cargoType'] = cargoType
      }
      if (isSameLoadingPort) {
        sameCondition['loadingPort'] = loadingPort
      }
      if (isSameDestinationPort) {
        sameCondition['destinationPort'] = destinationPort
      }
      if (isSameDestinationAgent) {
        sameCondition['destinationAgent'] = destinationAgent
      }
      if (isSameVesselLine) {
        sameCondition['vesselLine'] = vesselLine
      }
      this.chargeSchemeBatchDialog.source = this.addChargeDetailDialog.visible ? 'addCharge' : 'jobList'
      this.chargeSchemeBatchDialog.chargeType = null
      this.chargeSchemeBatchDialog.selectedJobs = selectedJobs
      this.chargeSchemeBatchDialog.job = this.selectedJob ? this.selectedJob : selectedJobs[0]
      this.chargeSchemeBatchDialog.isSea = false
      this.chargeSchemeBatchDialog.lob = 'AI'
      this.chargeSchemeBatchDialog.originalCondition = sameCondition
      this.chargeSchemeBatchDialog.visible = true
    },
    // 日志记录
    logHandle() {
      if (!this.currentRow.uuid) {
        return
      }
      switch (this.logCommand) {
        case this.$t('CargoMsg.Cargo_BusinessStatusChangeLog'):
          this.businessStatusDialog.visible = true
          break
        case this.$t('SeaExport.OperationLog'):
          this.dataUpdateLogDialog.visible = true
          this.dataUpdateLogDialog.isNeedExpand = true
          this.dataUpdateLogDialog.defaultIsExpand = true
          LocalStorageUtilsNew.setConfiguration('AIDataUpdateLogDialogVisible', true)
          break
      }
    },
    // sop双击事件
    onBtnListDoubleClicked() {
      LocalStorageUtils.setConfiguration('AISopStatusPopupVisible', true)
      this.sopStateDialog.visible = true
      this.sopStateDialog.defaultIsExpand = true
      this.sopStateDialog.isNeedExpand = true
    },
    resetSopTooltip(event) {
      this.sopTooltipOffset = event.offsetX
    },
    // sop关闭处理
    sopStateDialogClose() {
      this.sopStateDialog.defaultIsExpand = true
      LocalStorageUtils.setConfiguration('AISopStatusPopupVisible', false)
    },
    // log 关闭处理
    dataUpdateLogDialogClose() {
      this.dataUpdateLogDialog.defaultIsExpand = true
      LocalStorageUtilsNew.setConfiguration('AIDataUpdateLogDialogVisible', false)
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签切换
    handleTabClick() {
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
      })
    },
    // tab页签结束后的处理（在编辑状态下）
    async endTabHandler(tabName) {
      if (this.action === 'look') {
        return
      }
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // 重置tab页签
    resetTab(tabName) {
      this.pendTabSet.delete(tabName)
    },
    // 重置数据
    resetData(keys) {
      for (const key of keys) {
        this.paramsOfTab[key] = deepCopy(this.currentRow[key])
      }
    },
    // 同步数据
    syncData(data) {
      Object.assign(this.currentRow, data)
    },
    addBatchLcl(lclJob) {
      this.againShow('addLcl', lclJob)
    },
    transferTargetRow(jobUuid) {
      const selectedRow = this.rowData.find(p => p.uuid === jobUuid)
      if (selectedRow) {
        console.log('transferTargetRow')
        console.log({ ...selectedRow })
        this.againShow('edit', selectedRow)
      }
    },
    // 加入小票
    addSlavedJob(jobs) {
      const jobKeys = []
      for (const job of jobs) {
        this.setJobExtraInfo(job)
        jobKeys.push(job.uuid)
      }
      const rows = this.rowData.filter(p => !jobKeys.includes(p.uuid)) // 过滤掉旧数据
      this.rowData = [...rows, ...jobs]
      this.saveJobNos.push(this.currentRow)
      this.saveJobNos.push(...jobs)
      for (let i = this.removedJobNos.length - 1; i >= 0; --i) {
        if (jobs.findIndex(p => p.uuid === this.removedJobNos[i].uuid) >= 0) {
          this.removedJobNos.splice(i, 1)
        }
      }
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
      this.isRefresh = true
    },
    // 移除小票
    removeJobFromMaster(jobKeys) {
      const rows = this.rowData.filter(p => !jobKeys.includes(p.uuid))
      const removedRows = this.rowData.filter(p => jobKeys.includes(p.uuid))
      this.rowData = rows
      this.saveJobNos.push(this.currentRow)
      this.removedJobNos.push(...removedRows)
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
      this.isRefresh = true
    },
    // 保存业务相关数据
    async save() {
      // this.canSave = false
      const loading = getLoading4Cxt(this)
      try {
        if (this.processingPromiseList.length > 0) {
          const processingPromiseList = [...this.processingPromiseList]
          for (const processingPromise of processingPromiseList) {
            try {
              await processingPromise
            } catch (err) {
              console.log(err)
            }
          }
        }
        // 当前页签结束后的处理
        if (this.activeTabName) {
          await this.endTabHandler(this.activeTabName)
        }
        const body = { action: this.action }
        // 合并各页签的提交数据
        try {
          for (const item of this.pendTabSet) {
            const getSubmitData = this.$refs[item].getSubmitData
            if (getSubmitData && typeof getSubmitData === 'function') {
              let tabData = null
              const result = this.$refs[item].getSubmitData()
              if (result instanceof Promise) {
                tabData = await result
              } else {
                tabData = result
              }
              this.mergeObjectWithUuid(body, tabData)
            }
          }
          // 被联动修改了的数据
          this.mergeObjectWithUuid(body, this.context.modifiedData)
          // 待删除的数据
          this.mergeObjectWithUuid(body, this.context.removedData)
          if (this.action === 'copy' && this.paramsOfTab.charges && !body.charges) {
            body.charges = this.paramsOfTab.charges
          }
          // 清空job子表数据
          if (body.job) {
            // 拷贝一个副本，避免在保存成功前，影响原始数据
            if (body.job === this.paramsOfTab) {
              body.job = deepCopy(body.job)
            }
            for (const key in body.job) {
              if (typeof body.job[key] === 'object') {
                delete body.job[key]
              }
            }
          }
          cleanCircleObject(body)
          // 还原接单分公司
          if (this.useOrderCenterMode) {
            if (body.job && body.job.cooperateUuid) {
              body.job = { ...body.job }
              body.job.opOffice = body.job.opOffice_original || body.job.opOffice // 分公司
              body.job.op = body.job.op_original || body.job.op // 操作
              body.job.csr = body.job.csr_original || body.job.csr // 客服
              body.job.overseaOp = body.job.overseaOp_original || body.job.overseaOp // 海外操作
              body.job.dc = body.job.dc_original || body.job.dc // 单证
              body.job.planner = body.job.planner_original || body.job.planner // 航线负责人
              body.job.opDepartment = body.job.opDepartment_original || body.job.opDepartment // 操作部门
              JobUtils.restoreJobFromCooperateInfo(body.job)
            }
          }
          JobUtils.handleChargeForSave(body)
        } catch (err) {
          if (err instanceof TabError) {
            this.activeTabName = err.tabName
            if (err.message) {
              this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
            }
            return
          } else {
            throw err
          }
        }

        // 复制时校验费用名称是否被禁用
        if (this.action === 'copy') {
          const flag = await JobUtils.checkChargeItemDisabled(this, body.charges)
          if (!flag) {
            return
          }
        }
        // 后端触发SOP使用
        if (!this.isNew) {
          body.jobUuid = this.currentRow.uuid
        }

        // 获取业务对应的sop模板，若不一致，则提醒是否更换，若一致不处理，若新增，则
        await SopUtil.checkSopTemplate(body.job, this, null, null, this.sopTemplateConfig)

        // CARGO-48635 OCR识别 创建业务时，本地服务选择“门点提货”，则创建门点信息
        if (body.job && !body.job.uuid && this.action === ACTION_ADD.code && body.job.salesChannel === SALES_CHANNEL_OCR_RECOGNITION.code) {
          // 不等于【直单】时，将下面信息带入到分单信息中
          if (body.job.operateType !== DIRECT.code && body.airCargoDoc && body.airCargoDoc.length > 0) {
            // 进口操作-分单号 同步至 分单信息-HAWB NO
            body.airCargoDoc[0].hblNbr2 = body.job.hbl
            // 进口操作-发货人 同步至 分单信息-Shipper
            body.airCargoDoc[0].shipperLine1 = body.job.shipperLine1
            body.airCargoDoc[0].shipperLine2 = body.job.shipperLine2
            body.airCargoDoc[0].shipperLine3 = body.job.shipperLine3
            body.airCargoDoc[0].shipperLine4 = body.job.shipperLine4
            body.airCargoDoc[0].shipperLine5 = body.job.shipperLine5
            body.airCargoDoc[0].shipperLine6 = body.job.shipperLine6
            body.airCargoDoc[0].shipperLine7 = body.job.shipperLine7
            // 进口操作-收货人 同步至 分单信息-Consignee
            body.airCargoDoc[0].consigneeLine1 = body.job.consigneeLine1
            body.airCargoDoc[0].consigneeLine2 = body.job.consigneeLine2
            body.airCargoDoc[0].consigneeLine3 = body.job.consigneeLine3
            body.airCargoDoc[0].consigneeLine4 = body.job.consigneeLine4
            body.airCargoDoc[0].consigneeLine5 = body.job.consigneeLine5
            body.airCargoDoc[0].consigneeLine6 = body.job.consigneeLine6
            body.airCargoDoc[0].consigneeLine7 = body.job.consigneeLine7
            // 进口操作-通知人 同步至 分单信息-Notify
            body.airCargoDoc[0].notifyLine1 = body.job.notifyLine1
            body.airCargoDoc[0].notifyLine2 = body.job.notifyLine2
            body.airCargoDoc[0].notifyLine3 = body.job.notifyLine3
            body.airCargoDoc[0].notifyLine4 = body.job.notifyLine4
            body.airCargoDoc[0].notifyLine5 = body.job.notifyLine5
            body.airCargoDoc[0].notifyLine6 = body.job.notifyLine6
            body.airCargoDoc[0].notifyLine7 = body.job.notifyLine7
            // 进口操作-实际件数 同步至 分单信息-Airport of Departure
            const airports = await getSpecificBasicData(basicCacheKeys.basic_data_Airport)
            const ports = airports.filter(p => p.code === body.job.loadingPortCode)
            if (ports.length > 0) {
              // 提单起运港
              body.airCargoDoc[0].airportOfDeparture = ports[0].englishName
            }
            // 进口操作-实际件数 同步至 分单信息-Airport of Destination
            const desPorts = airports.filter(p => p.code === body.job.dischargingPortCode)
            if (desPorts.length > 0) {
              // 提单目的港
              body.airCargoDoc[0].airportOfDestination = desPorts[0].englishName
            }
            // 进口操作-实际件数 同步至 分单信息-Pieces
            body.airCargoDoc[0].quantity = body.job.quantityActual
            // 进口操作-实际毛重 同步至 分单信息-Gross Weight
            body.airCargoDoc[0].weight = body.job.weightActual
            // 进口操作-实际体积 同步至 分单信息-Volume
            body.airCargoDoc[0].cubage = body.job.cubageActual
            body.airCargoDoc[0].cWeight = body.job.chargeWeight
            // 进口操作-英文品名 同步至 分单信息-Nature and Quantity of Goods
            body.airCargoDoc[0].cargoEnglishName = body.job.cargoEnglishName
            // 进口操作-备注 同步至 分单信息-remark
            body.airCargoDoc[0].remark1 = body.job.remarks
          }
          // 避免isExistHBL接口中etd接收null，每有秒会变成null
          body.job.etd = body.job.etd && body.job.etd.length === 16 ? body.job.etd + ':00' : body.job.etd
          this.paramsOfTab.etd = body.job.etd
        }

        // 若为自揽货 清空指定货代理取值
        if (body.job && body.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
          body.job.designationAgent = 0
        }

        // 在保存前进行校验
        if (!(await this.checkBeforeSave(body))) {
          return
        }
        // 获取复制份数
        if (Reflect.has(body, 'job') && Reflect.has(body.job, 'copyNum') && Number(body.job.copyNum) > 1) {
          this.copyJobNum = Number(body.job.copyNum)
        }

        // CARGO-16870 验证规则节点增加“业务保存”
        const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
        if (useCheckRule && body && body.hasOwnProperty('job') && body.job) {
          const hasCheckRuleForSaveJob = await JobUtils.hasCheckRuleCondition(useCheckRule, CheckRuleConstants.NODE_SAVE_BUSINESS.code, this.$store.getters.currentOfficeId)
          if (hasCheckRuleForSaveJob) {
            const result = await JobUtils.checkBySaveJobNode({ ...body, charges: this.paramsOfTab.charges }, this.currentRow.lob, CheckRuleConstants.NODE_SAVE_BUSINESS.code)
            if (result.needShowDialog) {
              loading.close()
              const callBack = async() => { await this.continueSaving(body, loading, true) }
              this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_BUSINESS.code
              this.checkingSaveJobWindow.rowData = result.rowData
              this.checkingSaveJobWindow.callBack = callBack
              this.checkingSaveJobWindow.visible = true
            } else {
              await this.continueSaving(body, loading, false)
            }
          } else {
            await this.continueSaving(body, loading, false)
          }
        } else {
          await this.continueSaving(body, loading, false)
        }
      } finally {
        loading.close()
      }
    },
    // 合并对象属性，通过比较uuid判断对象是否相等
    mergeObjectWithUuid(target, source) {
      for (const key in source) {
        const srcValue = source[key]
        const targetValue = target[key]
        if ((srcValue instanceof Array) && (targetValue instanceof Array)) {
          for (const item of srcValue) {
            const index = targetValue.findIndex(p => p.uuid === item.uuid && p.uuid)
            if (index < 0) {
              targetValue.push(item)
            }
          }
        } else {
          target[key] = srcValue
        }
      }
    },
    // 在保存前进行校验
    async checkBeforeSave(data) {
      const job = this.paramsOfTab
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(job.customerId, !(job.uuid && job.customerId === this.currentRow.customerId))
      if (blacklist) {
        if (!job.uuid || (job.uuid && job.customerId !== this.currentRow.customerId)) {
          return false
        }
      }
      const reqInputCharge = Number(this.context.config.get('saveCharge')) === 1
      const isBookingFeeMandatoryAppliedGlobally = Number(this.context.config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
      if (!SecurityUtil.checkSaveCharge(reqInputCharge, job, isBookingFeeMandatoryAppliedGlobally)) {
        return false
      }
      let flag = await CreditControlUtil.checkCreditBlack(job, !blacklist, this.currentRow)
      if (!flag) {
        return false
      }
      if (!job.uuid) {
        flag = await EstimateProfitUtil.checkEstimate(job, params => {
          let resolveRef = null
          const result = new Promise(resolve => {
            resolveRef = resolve
          })
          const dialog = this.estimateValidationDialog
          dialog.job = params.job
          dialog.estimateProfitRate = params.estimateProfitRate
          dialog.tatolProfit = params.tatolProfit
          dialog.callback = isSave => {
            resolveRef(isSave)
          }
          dialog.visible = true
          return result
        })
        if (data && data.job) {
          data.job.estimateAccountsReceivable = job.estimateAccountsReceivable
          data.job.estimateAccountsPayable = job.estimateAccountsPayable
          data.job.estimateAccountsPayable = job.estimateAccountsPayable
          data.job.situation = job.situation
        }
        if (!flag) {
          return false
        }
      }
      flag = await this.checkChargeAccountId()
      if (!flag) {
        return false
      }
      flag = await this.checkDepartmentStep(data)
      if (!flag) {
        return false
      }
      // 新增情况下，验证是否填写自定义业务类型
      if (!job.uuid) {
        flag = await JobUtils.checkCustomJobType(job)
        if (!flag) {
          return false
        }
      }
      // 业务规则：DDP业务类型时，尾程商务负责人必填
      if (job && this.isCustomJobTypeDDP(job) && !job.userDefinedRoleId6) {
        // 引导用户回到“基本”页签填写
        if (this.activeTabName) {
          this.activeTabName = job.masterFlag ? 'tabBookingMaster' : 'tabBookingFCL'
        }
        this.$message.warning(this.$t('Message.FieldValueCannotBeNull', [this.$t('CargoMsg.Cargo_LastMileBusinessLeader')]))
        return false
      }
      flag = await JobUtils.checkHBLANDMBL(job)
      if (!flag) {
        return false
      }
      flag = await this.checkMblRepeatOrNot(job)
      if (!flag) {
        return false
      }
      const needConfirmProjectNo = Number(this.context.config.get('needConfirmProjectNo')) === 1
      // needConfirmProjectNo【是否要验证项目编号重复】; openProjectConfig【是否开启项目管理】
      if (job.poNo && needConfirmProjectNo && Number(this.context.config.get('openProjectConfig')) === 0) {
        flag = await JobUtils.isPoNoExist(job.poNo, job.uuid)
        if (!flag) {
          return false
        }
      }
      return flag
    },
    // 自定义业务类型为 DDP 时，需要填写尾程商务负责人
    isCustomJobTypeDDP(job) {
      const code = job && job.customJobType
      if (!code) return false
      // 检查是否为DDP相关业务类型
      return code === 'DDP' || code === 'EDDP' || code === 'REDDP' || code === 'RIDDP'
    },
    // 验证费用结算对象
    async checkChargeAccountId() {
      const job = this.paramsOfTab
      let messageTitle = ''
      let company = null
      if (job.charges && job.charges.length > 0) {
        for (const charge of job.charges) {
          if (charge.accountId > 0) {
            company = this.context.companyList.find(p => p.cmpIdx === charge.accountId)
            if (company && !company.active) {
              if (!this.chargeAccountIdObject || !this.chargeAccountIdObject[company.uuid]) {
                if (company.chineseName) {
                  messageTitle = this.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.chineseName)
                } else {
                  messageTitle = this.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.englishName)
                }
                break
              }
            }
          }
        }
      }
      if (messageTitle) {
        return await this.$confirm(messageTitle, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('constant.yes'),
          cancelButtonText: this.$t('constant.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.chargeAccountIdObject = this.chargeAccountIdObject || {}
          this.chargeAccountIdObject[company.uuid] = company.uuid
          return true
        }).catch(() => false)
      } else {
        return true
      }
    },
    async checkDepartmentStep(data) {
      const job = this.paramsOfTab
      if (!job.airCargoDoc) {
        return true
      }
      let hblNbr2 = ''
      if (data.action === 'edit' && job.airCargoDoc.length === 0 && data.airCargoDoc) {
        // 兼容 hbl第一次编辑保存场景
        for (const item of data.airCargoDoc) {
          if (item.docType === 'HAWB') {
            hblNbr2 = item.hblNbr2
            break
          }
        }
      } else if (job.airCargoDoc.length === 0 && job.hbl) {
        // 兼容 hbl未切换 基本页签同步场景
        hblNbr2 = job.hbl
      } else {
        for (const item of job.airCargoDoc) {
          if (item.docType === 'HAWB') {
            hblNbr2 = item.hblNbr2
            break
          }
        }
      }
      if (hblNbr2 && Number(this.context.config.get('isAllowAIHBLNoRepeat')) === 1) {
        const res = await isExistHBL({ branchId: this.$store.getters.currentOfficeId, lob: 'AI', hbl: hblNbr2, jobUuid: job.uuid, etd: job.etd })
        if (res.data > 0) {
          this.$message.warning(this.$t('Message.HBLRepeatedContinue'))
          return false
        }
      }
      return true
    },
    saveDefaultVal() {
      this.context.loading = true
      EntityDefaultValueUtil.getInstance().saveEntityDefaultValue(['Job', 'AirImportJob'], this.paramsOfTab).then(() => {
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        this.context.loading = false
      })
    },
    // 取消编辑
    cancelEdit() {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        // CARGO-33145 空运进口取消编辑时从Map中移除
        JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_AI, true, this.currentRow ? this.currentRow.jobNo || '' : '')
        if (this.isNew) {
          if (this.rowData.length > 1) {
            this.rowData = this.rowData.filter(p => p.uuid)
            this.currentRow = this.rowData[0]
            this.lookHandler()
          } else {
            this.goBack()
          }
        } else if (this.action === 'edit') {
          this.lookHandler()
        }
      }).catch()
    },
    goBack() {
      /* saveJobNos去重 */
      const map = new Map()
      for (const item of this.saveJobNos) {
        const newJob = {}
        for (const key in item) {
          if (typeof item[key] === 'object') {
            continue
          }
          newJob[key] = item[key]
        }
        delete newJob.isCompleteRow
        delete newJob.version
        map.set(item.uuid, newJob)
      }
      const saveJobNos = [...map.values()]
      this.$emit('back', saveJobNos, this.removedJobNos)
      setTimeout(() => {
        this.$store.dispatch('app/setCanCloseModule', true)
      }, 500)
    },
    // 保存剩下的复制业务【后台复制并保存】
    async saveCopyJobHandle(jobUuid, copyNum, masterFlag) {
      const item = {}
      item.jobUuid = jobUuid
      item.branchId = this.$store.getters.currentOfficeId
      const lob = this.currentRow.lob
      if (masterFlag) {
        item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob + '_MASTER')
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob + '_MASTER')
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob + '_MASTER')
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob + '_MASTER')
        item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob + '_MASTER')
      } else {
        item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob)
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob)
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob)
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
        item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob)
      }
      item.copyNum = copyNum
      item.masterFlag = masterFlag
      item.all = true
      item.copyOnly = true // 是否是复制业务，新增业务日志时使用
      item.location = this.location
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            copyJob.jobUuid = copyJob.uuid
            copyJob.parentUuid = copyJob.uuid
            copyJob.path = copyJob.uuid
            copyJob.dataType = 2 // 小票
            this.saveJobNos.push(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    async updateJob() {
      const data = {}
      for (const key in this.paramsOfTab) {
        if (typeof this.paramsOfTab[key] === 'object') {
          continue
        }
        data[key] = this.paramsOfTab[key]
      }
      const loading = getLoading4Cxt(this)
      const res = await saveJobInfo(data).finally(() => {
        loading.close()
      })
      await this.mergeCurrentRow(res)
      this.againShow()
    },
    async continueSaving(body, loading, closingLoading = false) {
      try {
        if (closingLoading) {
          loading = getLoading4Cxt(this)
        }
        // 保存到数据库
        const oldBusinessDate = this.currentRow.eta
        const businessDate = this.paramsOfTab.eta
        const charges = this.paramsOfTab.charges
        body.location = this.location
        body.receiptCharges = this.context.receiptCharges
        let blockCreditData = null
        await this.saveAirImportFunc(body).then(res => {
          const result = res.data.job
          if (result) {
            Object.assign(this.currentRow, result)
            this.setJobExtraInfo(this.currentRow)
            this.isRefresh = true
            this.saveJobNos.push(this.currentRow)
          }
          /* 重置受影响的行数据 */
          let dirtyRows = null
          if (this.currentRow.masterFlag) {
            dirtyRows = this.rowData.filter(p => p.lclMasterUuid === this.currentRow.uuid)
          } else if (this.currentRow.lclMasterUuid) {
            dirtyRows = this.rowData.filter(p => p.uuid === this.currentRow.lclMasterUuid)
          }
          this.reset(dirtyRows ? [...dirtyRows, this.currentRow] : [this.currentRow])
          if (this.isNew) {
            this.gridApi.setRowData(this.rowData)
          }
          blockCreditData = res.data.blockCreditData
        })
        // 复制多份业务 保存的处理逻辑
        if (this.copyJobNum > 1 && this.currentRow.uuid) {
          await this.saveCopyJobHandle(this.currentRow.uuid, this.copyJobNum - 1, this.currentRow.masterFlag)
        }
        // 主票页签新增小票后，需切换回主票
        if (this.action === 'addLcl') {
          const job = this.currentRow
          this.currentRow = this.rowData.find(p => p.uuid === job.lclMasterUuid)
          this.currentRow.version = 0
        }
        // 保存成功后执行各业签的回调方法
        for (const item of this.pendTabSet) {
          const executeTask = this.$refs[item].executeTask
          if (executeTask && typeof executeTask === 'function') {
            const result = this.$refs[item].executeTask()
            if (result instanceof Promise) {
              await result
            }
          }
        }
        if (JobUtils.isBlockJob(this.currentRow)) {
          // 保存成功之后如果是信控锁住则会弹此提示【Job.as中的save方法】
          setTimeout(() => {
            this.$message.warning(this.$t('SeaExport.CheckCreditSaveTip'))
          }, 2000)
        }
        // 保存业务触发SOP后需要刷新SOP操作状态弹框
        if (this.sopStateDialog.visible) {
          setTimeout(() => {
            this.sopStateDialog.isNeedRefresh = true
          }, 3000)
        }
        // 保存业务后需要刷新 变更日志记录弹框
        if (this.dataUpdateLogDialog.visible) {
          setTimeout(() => {
            this.dataUpdateLogDialog.isNeedRefresh = true
          }, 3000)
        }
        this.againShow('look')
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        /* if (this.currentRow.jobState === 0 && businessDate !== oldBusinessDate && ChargeUtils.ChargeUtils.exchangeRateNeedUpdate(charges, businessDate)) {
          setTimeout(() => {
            this.$message.success(this.$t('queryJob.BusinessDateChangedUpdateExchangeRate'))
          }, 100)
        }*/
        JobUtils.handleCreditRemind(this.currentRow, blockCreditData)
      } catch (err) {
        throw err
      } finally {
        if (closingLoading) {
          loading.close()
        }
      }
    },
    async saveAirImportFunc(body) {
      // 数据已被其他人修改
      let dataModified = false
      let userName = ''
      let modifyDate = ''
      let err = null
      try {
        return await saveAirImport(body, true, true)
      } catch (res) {
        let error17 = null
        if (res.errors) {
          error17 = res.errors.find(p => p.code === '0017')
        }
        if (error17) {
          dataModified = true
          const start = error17.message.indexOf('[')
          if (start > -1) {
            const end = error17.message.indexOf(']', start)
            if (end > -1) {
              userName = error17.message.substring(start + 1, end)
            }
          }
          const match = error17.message.match(/[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}/)
          modifyDate = match[0] || ''
          err = res
        } else {
          this.$message({
            showClose: true,
            message: res.errorMsg,
            dangerouslyUseHTMLString: res.errorMsg && res.errorMsg.indexOf('<br/>') > -1,
            type: 'error',
            duration: 5 * 1000
          })
          throw res
        }
      }
      if (dataModified) {
        const oldData = lodash.cloneDeep(this.currentRow) // 旧版本的数据
        const editOldData = lodash.cloneDeep(this.paramsOfTab) // 正在编辑的旧版本的数据
        const pendTabs = [...this.pendTabSet]
        const modifiedData = { ...this.context.modifiedData }
        this.currentRow.version = 0
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
        await this.onRowClicked({ data: this.currentRow, skipTabHandle: true })
        if (pendTabs.includes('tabTradeDetail')) {
          await new AirImportJob(this.currentRow).getPoItems()
        }
        if (pendTabs.includes('tabTradeCommission')) {
          await new AirImportJob(this.currentRow).getPoList()
        }
        if (pendTabs.includes('tabUsCustomsClearance')) {
          await this.$refs['tabUsCustomsClearance'].onShow(this.paramsOfTab, true)
        }
        if (pendTabs.includes('tabUsCustomsClearanceMaster')) {
          await this.$refs['tabUsCustomsClearanceMaster'].onShow(this.paramsOfTab, true)
        }
        const newData = this.currentRow // 最新版本的数据
        this.paramsOfTab = JobUtils.compareAndMergeJobData(oldData, editOldData, newData)
        this.pendTabSet.clear()
        for (const pendTab of pendTabs) {
          this.pendTabSet.add(pendTab)
          this.$refs[pendTab].onShow(this.paramsOfTab, true)
        }
        const filedMap = new Map([['truckingInfo', 'trucking']])
        for (const key in modifiedData) {
          const sourceKey = filedMap.get(key) || key
          if (modifiedData[key] instanceof Array && this.paramsOfTab[sourceKey] instanceof Array) {
            const targetArray = modifiedData[key]
            const souceArray = this.paramsOfTab[sourceKey]
            for (let i = 0; i < targetArray.length; ++i) {
              const sourceItem = souceArray.find(p => p === targetArray[i] || (p.uuid && p.uuid === targetArray[i].uuid))
              if (sourceItem) {
                targetArray[i] = sourceItem
              }
            }
            this.context.modifiedData[key] = modifiedData[key]
          }
        }
        const flag = await this.$confirm(this.$t('queryJob.DataModifiedHasMergeContinueSave', [userName, modifyDate]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('Message.Yes'),
          cancelButtonText: this.$t('Message.No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (flag) {
          const newBody = {}
          if (body.job) {
            newBody.job = { ...this.paramsOfTab }
            // 还原接单分公司
            if (this.useOrderCenterMode) {
              if (newBody.job.cooperate && newBody.job.cooperate.uuid) {
                newBody.job.opOffice = newBody.job.opOffice_original || newBody.job.opOffice // 分公司
                newBody.job.op = newBody.job.op_original || newBody.job.op // 操作
                newBody.job.csr = newBody.job.csr_original || newBody.job.csr // 客服
                newBody.job.overseaOp = newBody.job.overseaOp_original || newBody.job.overseaOp // 海外操作
                newBody.job.dc = newBody.job.dc_original || newBody.job.dc // 单证
                newBody.job.planner = newBody.job.planner_original || newBody.job.planner // 航线负责人
                newBody.job.opDepartment = newBody.job.opDepartment_original || newBody.job.opDepartment // 操作部门
                JobUtils.restoreJobFromCooperateInfo(newBody.job)
              }
            }
            for (const key in newBody.job) {
              if (newBody.job[key] instanceof Object) {
                newBody.job[key] = ''
              }
            }
          }
          for (const key in body) {
            if (key === 'job') {
              continue
            }
            const sourceKey = filedMap.get(key) || key
            if (body[key] instanceof Array) {
              if (this.paramsOfTab[sourceKey] instanceof Array) {
                const uuids = []
                newBody[key] = []
                for (const bodyItem of body[key]) {
                  if (bodyItem.uuid) {
                    uuids.push(bodyItem.uuid)
                  } else {
                    newBody[key].push(bodyItem)
                  }
                }
                for (const mergeItem of this.paramsOfTab[sourceKey]) {
                  if (uuids.includes(mergeItem.uuid)) {
                    newBody[key].push(mergeItem)
                  }
                }
              } else {
                newBody[key] = body[key]
              }
            } else if (body[key] instanceof Object) {
              newBody[key] = this.paramsOfTab[sourceKey] || body[key]
            } else {
              newBody[key] = body[key]
            }
          }
          cleanCircleObject(newBody)
          return await saveAirImport(newBody, true)
        } else {
          throw err
        }
      }
    },
    async checkMblRepeatOrNot(job) {
      if (!job.mbl || StrUtils.isEmpty(job.mbl) || !job.opOffice) return true
      // 一主多分情况下,如果是小票并且关联了主票，则不进行校验
      if (job.operateType === 0 && !job.masterFlag && job.lclMasterUuid) return true
      const result = await checkMblRepeatOrNot({ 'key': job.uuid, 'operateType': job.operateType, 'mbl': job.mbl, 'opOffice': job.opOffice, 'masterJob': job.masterFlag }).then(res => res.data)
      if (!result) {
        let pass = false
        await this.$confirm(this.$t('Message.RepeatMblForSave'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.yes'),
          cancelButtonText: this.$t('common.btn.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          pass = true
        }).catch(() => {
          pass = false
        })
        return pass
      } else {
        return true
      }
    },
    // 协作
    cooperationHandler() {
      this.cooperationBranchListDialog.jobUuid = this.paramsOfTab.uuid
      this.cooperationBranchListDialog.job = this.paramsOfTab
      this.cooperationBranchListDialog.orderCenterBranch = this.orderCenterBranch
      this.cooperationBranchListDialog.visible = true
    },
    // 退回
    cooperationReturnHandler() {
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureReturn'), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        this.toCooperationReturn()
      }).catch(() => {
        //
      })
    },
    toCooperationReturn() {
      const loading = getLoading4Cxt(this)
      updateState({ jobUuid: this.paramsOfTab.uuid, branchId: this.$store.getters.currentOffice.officeId, statusType: SystemConstants.STATUSTYPE_COOPERATE.code, status: SystemConstants.COOPERATE_STATUS_RETURNED.code }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ReturnedSuccess'))
      }).finally(() => {
        loading.close()
      })
    },
    // im入口值返回
    async getImGroupFunc(paramsOfTab) {
      const result = paramsOfTab.data
      if (!this.imCacheKey || !result || (result && !result.jobNo)) {
        return
      }
      let etdTime = ''
      if (result && result.etd) {
        etdTime = result.etd.slice(0, 10)
      } else {
        etdTime = ''
      }
      const imGroupName = `${result.jobNo}-${etdTime}-${ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', result.dischargingPortCode, 'englishName')}`
      const userInfo = this.$store.getters.userInfo
      // 销售 揽货销售 海外客服 航线负责人 现场操作 单证 自定义岗位1 自定义岗位2
      const personnel = ['sales', 'cargoSalesId', 'overseaOp', 'planner', 'siteOP', 'dc', 'csr', 'userDefinedRoleId1', 'userDefinedRoleId2', 'op']
      const data = {
        tenantId: userInfo.tenantId,
        cargowareCompanyId: result.customerId, // cargoware的合作伙伴，对应b2b的订舱公司
        loginUserId: userInfo.userId,	// 登陆人userId
        customerEmail: result.contactEmail, // 客户邮箱
        otherUserIdList: [userInfo.userId], // 其他内部人userId，userName
        docId: result.jobNo, // 单据Id
        type: '' // 单据type
      }
      if (!data.customerEmail) {
        await this.loadCustomer(data, result)
      }
      for (const item of personnel) {
        if (result[item]) {
          data.otherUserIdList.push(result[item])
        }
      }
      this.$refs.cargoIm.onShow(data, imGroupName)
    },
    async loadCustomer(data, result) {
      console.log('result.customerId======', result)
      let company = { cmpIdx: result.customerId }
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts) {
        for (const contact of contacts) {
          if (contact.contactPerson === result.customerContact) {
            data.customerEmail = contact.email
            break
          }
        }
      }
    },
    // 审批发起回调
    applyCloseAndRefresh() {
      this.jobApplyDialog.visible = false
      this.currentRow.version = 0
      this.lookHandler()
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    updateJobCooperate(cooperatebranch) {
      this.currentRow.cooperatebranch = cooperatebranch ? cooperatebranch.split(',').join(' | ') : ''
    },
    // 加载完job走这里
    initInfo() {
      this.showJobTitle()
      this.checkProvisionPublishedStatus()
    },
    async showJobTitle() {
      const job = this.currentRow
      this.commonInfo.jobTitle = ''
      const detailModel = Number(this.context.config.get('DetailTitleShowModel')) || 0
      const mawbMid = detailModel === 0 ? this.formatAiJobTitleMawbSegment(job) : null
      if (job.customerId) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await JobUtils.getBillingTypeByCompany(cmp)
          const inner =
            '<span style="margin-right:10px">' + creditTerm + '</span><span>' + billingType + '</span>'
          /** look：主单号已由模板 stateInfo.titleMblMid 展示，此处只拼账期/开票，避免重复 */
          if (this.action === 'edit' && detailModel === 0 && mawbMid !== null) {
            this.commonInfo.jobTitle =
              '<span style="margin-right:10px">' + mawbMid + '</span>' + inner
          } else {
            this.commonInfo.jobTitle = inner
          }
        }
      } else if (this.action === 'edit' && detailModel === 0 && mawbMid !== null) {
        this.commonInfo.jobTitle =
          '<span style="margin-right:10px">' + mawbMid + '</span>'
      }
    },
    // 检查计提发布状态
    async checkProvisionPublishedStatus() {
      if (!this.currentRow || !this.currentRow.uuid) {
        this.commonInfo.provisionLock = { etdLocked: false, feeLocked: false }
        return
      }

      try {
        const res = await checkJobProvisionFlag(this.currentRow.uuid)
        this.commonInfo.provisionLock = res.ok ? normalizeProvisionLock(res.data) : { etdLocked: false, feeLocked: false }
      } catch (error) {
        console.error('检查计提发布状态失败:', error)
        this.commonInfo.provisionLock = { etdLocked: false, feeLocked: false }
      }
    },
    toChangeSchema() {
      // 先打开费用方案弹框，选择方案后再带入到新增费用弹框
      this.toImportCharge()
    },
    // 处理费用方案选择
    handleSelectedScheme(selectedScheme) {
      // 关闭费用方案弹框
      this.chargeSchemeBatchDialog.visible = false
      // 打开新增费用弹框，并带入选择的费用方案
      this.addChargeDetailDialog.selectedJobs = [this.currentRow]
      this.addChargeDetailDialog.selectedScheme = selectedScheme
      this.addChargeDetailDialog.visible = true
    }
  }
}
